import { showErrorMessage } from "../constants";
import { apiClient, formDataApiClient } from "./apiClient";

export class apiEndPoints {
  static extractError(error) {
    let extracted;
    if (error.isAxiosError) {
      if (error.request) {
        extracted = ["Network error"];
      } else if (error.response) {
        extracted = [error.response.message];
      } else {
        extracted = ["An unexpected error occured"];
      }
    } else {
      extracted = [error.response.message || "An unexpected error occurred"];
    }
    extracted.forEach((error) => showErrorMessage(error));
  }

  static async signIn(data) {
    try {
      return apiClient.post("/user_login", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async signUp(data) {
    try {
      return apiClient.post("/user_account_creation", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async generateToken(data) {
    try {
      return apiClient.post("/generate_token", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async resetPassword(data) {
    try {
      return apiClient.post("/update_security_details", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async updatePassword(data) {
    try {
      return apiClient.post("/update_user_password", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async campaignCategories(data) {
    try {
      return apiClient.get("/needy_category", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async campaignList(data) {
    try {
      return apiClient.get("/short_campaigns", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async faqs(data) {
    try {
      return apiClient.get("/list_faq", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async filterCampaignList(categoryID) {
    try {
      return apiClient.get(
        `/short_campaigns?status=0&needy_category_id=${categoryID}`
      );
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async donationList(campaignReference) {
    try {
      return apiClient.get( `/campaign_recent_donations?campaign_reference=${campaignReference}`);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async userCampaigns(email) {
    try {
      return apiClient.get( `/short_campaigns?email=${email}`);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async totalAmountRaised(data) {
    try {
      return apiClient.get("/total_amount", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async campaignDetails(campaignReference) {
    try {
      return apiClient.post(`/full_campaigns`,  {campaign_reference: campaignReference});
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async campaignUpdates(campaignReference) {
    try {
      return apiClient.get(
        `/campaign_owner_comment_detail?campaign_id=${campaignReference}`
      );
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async campaignComments(campaignReference) {
    try {
      return apiClient.get(
        `/campaign_comment_detail?campaign_reference=${campaignReference}`
      );
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async sendcampaignComments(data) {
    try {
      return apiClient.post(
        "/campaign_comments", data
      );
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async sendcampaignUpdates(data) {
    try {
      return apiClient.post(
       "/campaign_owner_comment", data
      );
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async virtualAccount(campaignReference) {
    try {
      return apiClient.get( `/campaign_virtual_accounts?campaign_reference=${campaignReference}`);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async createCampaign(data) {
    try {
      return formDataApiClient.post(
       "/create_campaigns", data
      );
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async bankList(data) {
    try {
      return apiClient.get("/ngn_bank", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

  static async payWithFlutter(data) {
    try {
      return apiClient.post("/flutter_payment", data);
    } catch (error) {
      apiEndPoints.extractError(error);
      throw error;
    }
  }

}